const ComingSoon = () => {
  return (
    <div className="h-screen flex flex-col justify-center items-center bg-black text-white">
      <h1 className="text-5xl font-bold text-lime-400 mb-4">🚧 Coming Soon...</h1>
      <p className="text-lg text-gray-300">
        We’re working hard to bring this page live. Stay tuned!
      </p>
    </div>
  );
};

export default ComingSoon;
